/**
 * Anchor
 */

export default function () {
  if ($('.anchor-tag-js').length === 0) {
    return;
  }

  // Get all sections that have an ID defined
  const sections = document.querySelectorAll('.content-section[id]');

  function navHighlighter() {
    // Get current scroll position
    const scrollY = window.pageYOffset;

    // Loop through sections to get height, top and ID values for each
    sections.forEach((current) => {
      const sectionHeight = current.offsetHeight;
      const sectionTop =
        current.getBoundingClientRect().top + window.pageYOffset - 170;
      sectionId = current.getAttribute('id');
      if (scrollY > sectionTop && scrollY <= sectionTop + sectionHeight) {
        document
          .querySelector('.hero-child-title--nav a[href*=' + sectionId + ']')
          .classList.add('active');
      } else {
        document
          .querySelector('.hero-child-title--nav a[href*=' + sectionId + ']')
          .classList.remove('active');
      }
    });
  }

  // this will get the full URL at the address bar
  let url = window.location.href;

  $(".nav a").each(function() {
      // checks if its the same on the address bar
      if (url == (this.href)) {
          $(this).closest("li").addClass("nav__nav-active");
          //for making parent of submenu active
        $(this).closest("li").parent().parent().addClass("active");
      }
  });

  // Scroll on click 
  $('.anchor-tag-js').click(function () {
    $('html, body').animate(
      {
        scrollTop: $($.attr(this, 'href')).offset().top - 170,
      },
      700
    );
  });

  // On page load scroll to section
  setTimeout(function () {
    if (location.hash) {
      window.scrollTo(0, 200);
      const target = location.hash.split('#');
      smoothScrollTo($('#' + target[1]));
    }
  }, 1);

  function smoothScrollTo(target) {
    target = target.length ? target : $('[name=' + this.hash.slice(1) + ']');

    if (target.length) {
      $('html,body').animate(
        {
          scrollTop: target.offset().top - 170,
        },
        700
      );
    }
  }
}
